<template>
  <!-- this is the old knowledge base -->
  <KnowledgeBaseSimplified
    v-if="showOldKnowledgeBase"
    :enable-create="$store.getters.canUserUploadContent"
  />
  <KnowledgeBase v-else/>
</template>

<script lang="ts">
  import KnowledgeBaseSimplified from './KnowledgeBaseSimplified.vue'
  import KnowledgeBase from '@/Domain/KnowledgeBase/Components/KnowledgeBase.vue'
  import UiMixin from '../../util/UiMixin.js'
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'KnowledgeBaseChooser',
    components: {
      KnowledgeBaseSimplified,
      KnowledgeBase
    },
    mixins: [UiMixin],
    computed: {
      showOldKnowledgeBase() {
        return !this.$store.getters.hasAccessToNewKnowledgeBase
      }
    }
  })
</script>
